import i18n from 'i18next';
import {FONT_SIZE, FontSize, IPresentationTheme, getFontSizeTranslationKey} from '../incase-domain/presentationTheme';
import {Option} from '../ui/components/common/Select';
import {IPresentation} from '../incase-domain/presentation';

export function setTextColor(
    size = 2,
    presentationTheme?: IPresentationTheme,
    selectedPresentation?: IPresentation
): {font: {color: string; size: number}} {
    const fontBlack = {font: {color: '#000000', size}};
    if (
        presentationTheme?.elementStyles?.textElement &&
        presentationTheme.elementStyles.textElement.color &&
        selectedPresentation?.presentationThemeId
    ) {
        fontBlack.font.color = presentationTheme.elementStyles.textElement.color;
    }
    if (
        presentationTheme?.elementStyles?.textElement &&
        presentationTheme.elementStyles.textElement.fontSize?.value &&
        selectedPresentation?.presentationThemeId
    ) {
        fontBlack.font.size = presentationTheme.elementStyles.textElement.fontSize.value;
    }
    return fontBlack;
}

export function getPresentationThemeFontSizeOptions(fontSizes: FontSize[] | undefined): Option[] {
    const options: Option[] = [];

    const sortedFontSizes =
        fontSizes &&
        fontSizes.slice().sort((a, b) => {
            const orderA = Object.values(FONT_SIZE).indexOf(a.size as FONT_SIZE);
            const orderB = Object.values(FONT_SIZE).indexOf(b.size as FONT_SIZE);
            return orderA - orderB;
        });

    if (sortedFontSizes) {
        sortedFontSizes.forEach((fontSize) => {
            const key = getFontSizeTranslationKey(fontSize.size);
            const localized = key ? i18n.t(key) : '';
            options.push({
                label: `${localized}: ${fontSize.value}` || '',
                value: fontSize.value?.toString() || '',
            });
        });
    } else {
        options.push({label: i18n.t('presentationThemesPage.noFontSizeOptions'), value: ''});
    }
    return options;
}

export function getUpdatedPresentationThemeElementStyles(presentationTheme: IPresentationTheme, size: FONT_SIZE, newValue: number): void {
    if (presentationTheme.elementStyles) {
        if (presentationTheme.elementStyles.textElement && presentationTheme.elementStyles.textElement.fontSize?.size === size) {
            // eslint-disable-next-line no-param-reassign
            presentationTheme.elementStyles.textElement.fontSize.value = newValue;
        }

        if (presentationTheme.elementStyles.questionElement) {
            const {questionElement} = presentationTheme.elementStyles;

            if (questionElement.questionFontSize && questionElement.questionFontSize.size === size) {
                questionElement.questionFontSize.value = newValue;
            }

            if (questionElement.answerFontSize && questionElement.answerFontSize.size === size) {
                questionElement.answerFontSize.value = newValue;
            }

            if (questionElement.commentFontSize && questionElement.commentFontSize.size === size) {
                questionElement.commentFontSize.value = newValue;
            }
        }
    }
}
